import { Link } from "react-router-dom";

export const Nav = () => (
  <header className="fixed top-0 left-0 right-0 z-50 bg-hearth-bg/90 backdrop-blur-md border-b border-hearth-line">
    <div className="max-w-7xl mx-auto px-6 py-4 grid grid-cols-[1fr_auto_1fr] items-center gap-6">
      <nav className="hidden md:flex items-center gap-8 text-sm font-body tracking-wide justify-start">
        <Link to="/story" data-testid="nav-story-link" className="text-hearth-muted hover:text-hearth-ink transition-colors">The Story</Link>
        <a href="/#sessions" data-testid="nav-sessions-link" className="text-hearth-muted hover:text-hearth-ink transition-colors">Sessions</a>
        <a href="/#words" data-testid="nav-words-link" className="text-hearth-muted hover:text-hearth-ink transition-colors">Words of Trust</a>
      </nav>
      <Link to="/" data-testid="nav-brand" className="flex items-center gap-3 justify-self-center group">
        <img src="/images/logo-mark.png" alt="Hat, beard and halo mark" className="h-14 w-auto" data-testid="nav-logo" />
        <span className="font-sign text-xl tracking-[0.14em] uppercase gilded-sign">
          No BS Counselling
        </span>
      </Link>
      <nav className="hidden md:flex items-center gap-5 text-sm font-body tracking-wide justify-end whitespace-nowrap">
        <a href="/#privacy" data-testid="nav-privacy-link" className="text-hearth-muted hover:text-hearth-ink transition-colors">The Pact</a>
        <Link to="/gift" data-testid="nav-gift-link" className="text-hearth-muted hover:text-hearth-ink transition-colors">Gift a Session</Link>
        <Link to="/merch" data-testid="nav-merch-link" className="text-hearth-ochre font-semibold hover:text-hearth-ink transition-colors border border-hearth-ochre/40 px-3 py-1.5">Merch</Link>
        <Link
          to="/book"
          data-testid="nav-book-button"
          className="bg-hearth-ember hover:bg-hearth-ochre hover:text-hearth-bg text-hearth-ink font-body font-semibold text-sm tracking-widest uppercase px-6 py-3 transition-colors"
        >
          Book a Session
        </Link>
      </nav>
    </div>
  </header>
);
